// extracted by mini-css-extract-plugin
export default {"title":"template-list-module__title--nlcHr","metadata":"template-list-module__metadata--AcWP2","Box":"template-list-module__Box--Rqcix","Box_1":"template-list-module__Box_1--OcLXl"};